import { EstadoNotaEletronica } from '../../enums/EstadoNotaEletronica.enum';

/**
 * Estado do cliente sob o qual o contador esta operando.
 * Fonte unica do valor do header X-Empresa-Contexto (lido pelo interceptor).
 * `null` = nenhum cliente selecionado (o header NAO e enviado).
 *
 * Modelo de ESTADO DE TELA (TS interno) — nao e um DTO de API.
 * Ver DESIGN_FE_contador-operar-cliente.md §"Modelo de Dados".
 */
export interface ContadorContextoState {
  /** Id da empresa do cliente (ClienteContadorConsultaDTO.empresaIndicadaId). */
  clienteEmpresaId: number;
  /** Nome do cliente — exibido na tela para o contador (leigo) saber em quem opera. */
  nomeCliente: string;
}

/**
 * Valor sentinela da opcao "Nao eletronica" no filtro de estado: filtra as notas
 * que sao fatura legal mas SEM estado da nota eletronica (NULL) — timbrado fisico
 * (autoimpressor/manual). Distinto de `null` ("Todos") e dos 9 estados eletronicos.
 */
export const FILTRO_NAO_ELETRONICA = 'NAO_ELETRONICA' as const;

/**
 * Valor sentinela da opcao "Nao emitida" no filtro de estado: notas do TIPO
 * eletronica (tipoNota = ELETRONICA) ainda NAO emitidas ao SIFEN (estado eletronico
 * NULL). Distingue-se de [[FILTRO_NAO_ELETRONICA]] (sem estado E nao eletronica).
 * No backend casa via semEstadoEletronico=true + tipoNota=ELETRONICA.
 */
export const FILTRO_NAO_EMITIDA = 'NAO_EMITIDA' as const;

/**
 * Opcao do dropdown de filtro por estado da nota eletronica (FormDTO).
 * `value` null = opcao "Todos" (sem filtro); [[FILTRO_NAO_EMITIDA]] = eletronica
 * ainda nao emitida; [[FILTRO_NAO_ELETRONICA]] = fatura legal nao eletronica. Os 9
 * estados espelham EstadoNotaEletronica; `label` e localizado via translate.
 */
export interface EstadoNotaEletronicaOpcaoFormDTO {
  label: string;
  value:
    | EstadoNotaEletronica
    | typeof FILTRO_NAO_EMITIDA
    | typeof FILTRO_NAO_ELETRONICA
    | null;
}

/**
 * Valores (chave do enum) dos 9 estados da nota eletronica, na ordem do contrato.
 * Usado para montar as opcoes do dropdown (o label vem do i18n
 * `enums.estado_nota_eletronica.<valor_minusculo>`).
 */
export const ESTADOS_NOTA_ELETRONICA_FILTRO: ReadonlyArray<EstadoNotaEletronica> = [
  EstadoNotaEletronica.EM_DEFINICAO,
  EstadoNotaEletronica.AUTORIZADA,
  EstadoNotaEletronica.CANCELADA,
  EstadoNotaEletronica.DENEGADA,
  EstadoNotaEletronica.INUTILIZADA,
  EstadoNotaEletronica.REJEITADA,
  EstadoNotaEletronica.ENVIADA,
  EstadoNotaEletronica.COM_PROBLEMAS,
  EstadoNotaEletronica.APROVADO,
];
